<div class="FormsFile">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly || openMode == 'edit') {
            <app-pg-file-preview [fileData]="elementData" [viewMode]="elementData?.type"></app-pg-file-preview>
        }
        @if (openMode == 'create') {
            <h4 class="mb-3">{{ 'forms-files.upload-files' | locTranslate }}</h4>
            <div class="container-fluid FormsFile-Upload border-top border-bottom py-3">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex pb-3">
                            <app-pg-switch [small]="true" [ariaLabel]="'forms-files.skip-present-files' | locTranslate" [(ngModel)]="skipPresentFiles"></app-pg-switch>
                            <div class="ms-2">{{ 'forms-files.skip-present-files' | locTranslate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div id="{{randomValue}}_upload_directories">
                        @if (saveDirectoriesProgress != null) {
                            <div class="pg-animation-slidedown mb-3">
                                <div class="mb-1" id="{{randomValue}}_upload_directories_label">{{ 'forms-files.preparing-upload' | locTranslate }}</div>
                                <div class="progress progress-thin">
                                    <div class="progress-bar {{ saveDirectoriesProgress == 1 ? 'bg-success' : '' }}"
                                        role="progressbar"
                                        [attr.aria-valuemin]="0"
                                        [attr.aria-valuemax]="100"
                                        [attr.aria-valuenow]="(saveDirectoriesProgress * 100) | number:'1.0-0'"
                                        [attr.aria-labelledby]="randomValue + '_upload_directories_label'"
                                        [style.width]="(saveDirectoriesProgress * 100) + '%'"></div>
                                </div>
                            </div>
                        }
                    </div>
                    @for (upload of uploadFiles; track upload; let i = $index) {
                        <div class="col-12 col-md-6 col-lg-4 pb-3">
                            <div class="FormsFile-Upload-Item pg-animation-slidedown" id="{{randomValue}}_upload_{{i}}">
                                <div>
                                    <app-pg-file-preview [fileData]="upload.file"></app-pg-file-preview>
                                    <div class="progress progress-thin">
                                        <div class="progress-bar {{ getResultProgressClass(upload.result) }}"
                                            role="progressbar"
                                            [attr.aria-valuemin]="0"
                                            [attr.aria-valuemax]="100"
                                            [attr.aria-valuenow]="(upload.progress * 100) | number:'1.0-0'"
                                            [attr.aria-label]="'forms-files.a11y.upload-progress' | locTranslate:'name':(upload.file?.name || '')"
                                            [style.width]="(upload.progress * 100) + '%'"></div>
                                    </div>
                                </div>
                                <div class="{{ isSaving ? 'opacity-00' : '' }}">
                                    @if (upload.result != 'success') {
                                        <button type="button" [disabled]="isSaving" class="btn btn-link text-danger" (click)="removeUploadFile(i)"
                                            [attr.aria-label]="'forms-files.a11y.remove' | locTranslate">
                                            <i class="fa-regular fa-trash fa-fw" aria-hidden="true"></i>
                                        </button>
                                    }
                                    @if (upload.result == 'success') {
                                        <button type="button" [disabled]="isSaving" class="btn btn-link text-success" (click)="removeUploadFile(i)"
                                            [attr.aria-label]="'forms-files.a11y.remove-success' | locTranslate">
                                            <i class="fa-regular fa-check fa-fw" aria-hidden="true"></i>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div class="row">
                    <div class="col-12 d-flex">
                        <div>
                            <app-pg-upload-button buttonIcon="fa-regular fa-file" buttonText="{{ 'forms-files.add-files' | locTranslate }}" [multiple]="true" (setFiles)="addUploadFiles($event)"></app-pg-upload-button>
                        </div>
                        <div class="ms-2">
                            <app-pg-upload-button buttonIcon="fa-regular fa-folder" buttonText="{{ 'forms-files.add-directory' | locTranslate }}" [directory]="true" [multiple]="true" (setFiles)="addUploadFiles($event)"></app-pg-upload-button>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (viewOnly) {
            <div>
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
            </div>
        }
        @if (!viewOnly) {
            <div class="container-fluid">
                <app-pg-form #formComponent [formLayout]="formLayout" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" (valueChange)="onValueChange($event)"></app-pg-form>
            </div>
        }
    }
</div>
